export default __webpack_public_path__ + "static/9-e5b9fbb597deb30d7a3d844ee6cb99c0.jpg";